import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useBoolean } from 'ahooks';
import { Col, Form, Row } from 'antd';

import { ISnapStore, snapStore } from 'containers/Snaps/Snap/store';
import { FieldByType } from 'components';

import { useGetRequest } from 'hooks';

import { Retailer } from 'codegen';

import { fields } from './lib';
import { LineItems } from './LineItems';
import { OCRActions } from './OCRActions';

const { useForm } = Form;

export const OCR = () => {
  const ocrScores = snapStore((state) => state.ocrScores);
  const ocrFormValues = snapStore((state) => state.ocrFormValues);
  const snapBooleanStatuses = snapStore((state) => state.snapBooleanStatuses);

  const { hasFlippedDayAndYear, enabledBaseIssuanceRetailer } = snapBooleanStatuses;

  const [form] = useForm<ISnapStore['ocrFormValues']>();
  const [isEditDisabled, { set }] = useBoolean(true);

  const { snapId } = useParams();

  const { data } = useGetRequest<{ retailers: Retailer[] }>({
    url: `/snaps/${snapId}/retailers`,
    options: {
      ready: !!snapId,
    },
  });

  useEffect(() => form.resetFields(), [ocrFormValues]);

  const retailers = useMemo(
    () => data?.retailers.map((retailer) => ({ ...retailer, label: retailer.name, value: retailer.id })),
    [data?.retailers],
  );

  return (
    <>
      <Form
        name='OCR'
        form={form}
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 17 }}
        disabled={isEditDisabled}
        initialValues={ocrFormValues}
        className='mb-5'
      >
        <Row>
          <Col xs={18} xl={14} xxl={10}>
            {fields({
              retailers,
              ocrScores,
              isEditDisabled,
              hasFlippedDayAndYear,
              enabledBaseIssuanceRetailer,
            }).map((field) => (
              <FieldByType
                key={field.label as string}
                field={field}
              />
            ))}
          </Col>

          <Col flex={1}>
            <Row justify='end'>
              <OCRActions
                set={set}
                isEditDisabled={isEditDisabled}
              />
            </Row>
          </Col>
        </Row>
      </Form>

      <Row>
        <Col xs={24}>
          <LineItems />
        </Col>
      </Row>
    </>
  );
};
